import {Component} from '@angular/core';
import {ICellEditorAngularComp, ICellRendererAngularComp} from 'ag-grid-angular/main';
import {forEach} from '@angular/router/src/utils/collection';

@Component({
  selector: 'app-radio-renderer-cell',
  templateUrl: './popover.component.html'
})
export class AnomaliesPopoverComponent implements ICellEditorAngularComp, ICellRendererAngularComp {
  params: any;

  agInit(params: any): void {
    this.params = params;
  }

  // demonstrates how you can do "inline" editing of a cell
  onChange($event) {
  }

  getValue() {
    if (this.params.node.group) {
      if (this.params.value === 'nuova anomalia') {
        return 'Affi. con Anomalie'; //'Nuove anomalie'
      } else if (this.params.value === 'da lavorare') {
        return 'Affi. con Anomalie'; //'In lavorazione'
      } else if (this.params.value === 'OK') {
        return 'Affiliata';  //'No anomalie'
      } else if (this.params.value === 'nuova affiliazione') {
        return 'Nuova affiliazione';
      } else if (this.params.value === 'richiesta affiliazione') {
        return 'Richiesta affiliazione';
      } else if (this.params.value === 'approvata') {
        return 'Approvata';
      } else if (this.params.value === 'da rinnovare') {
        return 'Da rinnovare';
      } else if (this.params.value === 'rifiutata') {
        return 'Rifiutata';
      } else if (this.params.value === 'Affiliata') {
        return 'Affiliata';
      }
    } else {
      if (this.params.data.affiliationState === 'nuova anomalia') {
        return 'Affi. con Anomalie'; //'Nuove anomalie'
      } else if (this.params.data.affiliationState === 'da lavorare') {
        return 'Affi. con Anomalie'; //'In lavorazione'
      } else if (this.params.data.affiliationState === 'OK') {
        return 'Affiliata';  //'No anomalie'
      } else if (this.params.data.affiliationState === 'nuova affiliazione') {
        return 'Nuova affiliazione';
      } else if (this.params.data.affiliationState === 'richiesta affiliazione') {
        return 'Richiesta affiliazione';
      } else if (this.params.data.affiliationState === 'approvata') {
        return 'Approvata';
      } else if (this.params.data.affiliationState === 'da rinnovare') {
        return 'Da rinnovare';
      } else if (this.params.value === 'rifiutata') {
        return 'Rifiutata';
      } else if (this.params.value === 'Nuova') {
        return 'Nuova';
      } else if (this.params.value === 'Attivata') {
        return 'Attivata';
      }else if (this.params.value === 'VISUALIZZATA') {
        return 'Visualizzata';
      } else if (this.params.value === 'Presa visione') {
        return 'Presa visione';
      } else if (this.params.value === 'Approva') {
        return 'Approva';
      } else if (this.params.value === 'Rifiuta') {
        return 'Rifiuta';
      } else if (this.params.value === 'Partecipo') {
        return 'Partecipo';
      } else if (this.params.value === 'Non partecipo') {
        return 'Non Partecipo';
      } else if (this.params.value === 'Forse') {
        return 'Forse';
      } else if (this.params.value === 'Affiliata') {
        return 'Affiliata';
      }
    }
  }

  getClass() {
    if (!this.params.node.group) {
      let className = 'btn-block btn btn-sm btn-raised btn-'
      if (this.params.data.affiliationState === 'nuova anomalia') {
        return className += 'success'; //  className += 'danger';
      } else if (this.params.data.affiliationState === 'da lavorare') {
        return className += 'success'; //className += 'warning';
      } else if (this.params.data.affiliationState === 'OK') {
        return className += 'success'; // lassName += 'primary';
      } else if (this.params.data.affiliationState === 'nuova affiliazione') {
        return className += 'primary';
      } else if (this.params.data.affiliationState === 'richiesta affiliazione') {
        return className += 'warning';
      } else if (this.params.data.affiliationState === 'approvata') {
        return className += 'success';
      } else if (this.params.data.affiliationState === 'da rinnovare') {
        return className += 'danger';
      } else if (this.params.value === 'rifiutata') {
        return className += 'danger';
      } else if (this.params.value === 'Attivata') {
        return className += 'success';
      } else if (this.params.value === 'Nuova') {
        return className += 'warning';
      } else if (this.params.value === 'VISUALIZZATA') {
        return className += 'success';
      } else if (this.params.value === 'Presa visione') {
        return className += 'success';
      } else if (this.params.value === 'Approva') {
        return className += 'success';
      } else if (this.params.value === 'Rifiuta') {
        return className += 'danger';
      } else if (this.params.value === 'Partecipo') {
        return className += 'success';
      } else if (this.params.value === 'Non partecipo') {
        return className += 'danger';
      } else if (this.params.value === 'Forse') {
        return className += 'warning';
      }else if (this.params.value === 'Affiliata') {
        return className += 'success';
      }
    }
  }

  getPopoverText() {
    return this.getPopoverTemplate(this.params.data.anomalies);
  }

  refresh(params: any): boolean {
    return false;
  }

  getPopoverTemplate(anomalies: any[]) {

    let template = '';
    anomalies.forEach(anomaly => {
      template += '<div><span class="mr-1">' + anomaly.code + '</span> ' + anomaly.description + '</div>';
    });
    return template;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/ag-grid-custom-components/anomalies-popover/popover.components.ts